// State object
const state = {
  isMobile: false,
};

// Mutations
const mutations = {
  setIsMobile(state, status) {
    state.isMobile = status;
  },
};

// Actions
const actions = {
  setIsMobile({ commit }, status) {
    commit('setIsMobile', status);
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
